<template>
  <div class="face-plate" v-show="showFlag" ref="plate" :style="style" @click.stop>
    <ul>
      <li v-for="(item, index) in faces" :key="index" :title="item.title" @click="click(index)">
        <img :alt="item.title" :src="item.url"/>
      </li>
    </ul>
    <BaseMask v-if="showFlag" @click.native.stop="hide($event)" :styles="{'background-color':'transparent', 'z-index': style['z-index'] - 1}"></BaseMask>
  </div>
</template>

<script>
    import bus from "../../js/bus/faceBus";
    import {faces} from "../../js/face";
    import BaseMask from "./BaseMask"
    import { nextZIndex } from "../../js/utils/zIndexUtil";
    import { lookElementXY } from "../../js/utils/domLocation";

    export default {
        name: "Face",
        components: {BaseMask},
        created() {
            //监听组件占用事件，传入占用标识、显示坐标参照物domRect对象、是否阻止组件事件
            bus.onShow((domRect) => {
                this.showFlag = true;
                this.$nextTick(() => {
                    this.style = lookElementXY(domRect, this.$refs.plate.getBoundingClientRect());
                    this.style['z-index'] = nextZIndex();
                    window.addEventListener('scroll', this.hide);
                });
            });
        },
        mounted() {
            this.$removeToBody();
        },
        data() {
            return {
                showFlag: false,
                faces: faces,
                style: {top: "0", left: "0", 'z-index': 0}
            }
        },
        methods: {
            click(index) {
                this.hide();
                bus.callback(this.faces[index]);
            },
            hide(e) {
                this.showFlag = false;
                window.removeEventListener('scroll', this.hide);
            },
        }
    }
</script>

<style scoped>
  @import '../../css/space_common.css';

  .face-plate {
    position: fixed;
  }

  .face-plate > ul {
    width: 364px;
    min-width: 364px;
    height: 239px;
    min-height: 239px;
    padding: 10px;
    border: 1px solid #D9D9D9;
    background-color: #fff;
    box-shadow: 0 0 20px rgba(0, 0, 0, .2);
  }

  .face-plate > ul > li {
    cursor: pointer;
    float: left;
    border: 1px solid #e8e8e8;
    height: 32px;
    width: 32px;
    margin: -1px 0 0 -1px;
    padding: 4px 4px;
    user-select: none;
    transition: background-color .2s ease;
  }

  .face-plate > ul > li:hover {
    background-color: #C9C5C5;
  }

  .face-plate > ul:after {
    content: '\20';
    clear: both;
    display: block;
    height: 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/baseComponent/Face.vue